<template>
<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path fill="currentColor" d="M3 9c0-4.969 4.031-9 9-9s9 4.031 9 9c0 6-7.5 11.25-7.5 11.25L15 24H9l1.5-3.75S3 15 3 9m4.5 0c0-2.484 2.016-4.5 4.5-4.5V3a6 6 0 0 0-6 6z"/></svg>
</template>